module.exports = __webpack_public_path__ + "static/media/main_visual_agriculture_telehandler_mlt_635_140_v_plus_manitou.95283469.png";